import { html as htmlPreact } from 'htm/preact';
import type { VNode } from 'preact';

/**
 * Preact + htm, no JSX.
 *
 * The repo's tsconfig sets no `jsx` option and this package does not own that
 * file, so tagged templates are the correct call rather than a workaround — and
 * htm is ~600 bytes on top of Preact, which matters because the same rendering
 * code is shared with the MCP Apps widget where bundle size is a hard constraint.
 */
export const html = htmlPreact as (
  strings: TemplateStringsArray,
  ...values: unknown[]
) => VNode;

export type { VNode };
